import { Category } from '@wix/answers-api';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import Image from 'next/image';
import { FunctionComponent } from 'react';

import { DATA_HOOKS } from '../../../dataHooks';

import css from './index.module.scss';

type WixelCategoryBannerProps = {
    category: Category;
};
export const WixelCategoryBanner: FunctionComponent<WixelCategoryBannerProps> = ({
    category,
}) => {
    const { name, description } = category;
    const { t } = useTranslation();
    return (
        <Box
            direction="horizontal"
            align="space-between"
            alignContent="center"
            padding={5}
            margin='7 0 5'
            borderRadius='8px'
            maxWidth='100%'
            boxSizing='border-box'
            className={css.WixelCategoryBannerWrapper}
            dataHook={DATA_HOOKS.WIXEL_CATEGORY_BANNER}
        >
            <Box direction="vertical" maxWidth='530px' gap={2} className={css.WixelCategoryBannerText}>
                <Heading appearance='H1' className={css.WixelCategoryBannerTitle}>
                    {name}
                </Heading>
                <Text size='small' className={css.WixelCategoryBannerDescription}>
                    {description}
                </Text>
            </Box>
            <Box className={css.WixelCategoryBannerImage}>
                <Image
                    src={'https://static.parastorage.com/services/kb-client-nextjs/dist/public/images/wixel-category-banner-icon/wixel-category-banner-icon.svg'}
                    width={88}
                    height={88}
                    alt={t('category-page.wixel-category-banner.image-alt')}
                    loading="lazy"
                />
            </Box>
        </Box>
    );
};
